
import { DataGroup } from "../../../models/dataGroup.model.ts";
import { DataGroupTeamSerializer } from "../../../models/serializers/dataGroupTeamSerializer.ts";
import { httpRequest } from "../../http";

export class CommandGetReferenceDataGroup {
  async runKeyDateTypes() {
    // const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/referencedatagroup/?name=engagement_objective_keydate_types`

    // const url = `${
    //   import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    // }api/v1/reference_data/groups`

    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/reference_data/groups/name/engagement_objective_keydate_types/items`

    try {
      const response = await httpRequest<any>(url, { method: "GET" })
      //TODO ADD SERIALIZER
      return response
      console.log(response)
      // return this.deserialize(response)
    } catch (error) {
      console.error("Error fetching data:", error)
      throw error
    }
  }

  deserialize(data: any): DataGroup[] {
    const serializer = new DataGroupTeamSerializer()
    return serializer.deserializeList(data)
  }
}

